export enum TypesReducer {
  SET_ARISAN_NAME = "SET_ARISAN_NAME",
  SET_ADMINISTRATOR_DATA = "SET_ADMINISTRATOR_DATA",
  CHANGE_LANGUAGE = "CHANGE_LANGUAGE",
  CHANGE_CURRENT_ROUTES = "CHANGE_CURRENT_ROUTES",
  CHANGE_PREVIOUS_ROUTES = "CHANGE_PREVIOUS_ROUTES",
  CHANGE_NEXT_ROUTES = "CHANGE_NEXT_ROUTES",
  SET_ARISAN_DATA = "SET_ARISAN_DATA",
  SET_ARISAN_MEMBERS = "SET_ARISAN_MEMBERS",
  SET_AUTHENTICATION = "SET_AUTHENTICATION",
  SET_ARISAN_SCHEDULE = "SET_ARISAN_SCHEDULE",
  REMOVE_ARISAN_DATA = "REMOVE_ARISAN_DATA",
  SET_ARISAN_KE = "SET_ARISAN_KE",
  SET_ALREADY_PAID = "SET_ALREADY_PAID",
  SET_ARISAN_KE_HAS_BEEN_VOTE = "SET_ARISAN_KE_HAS_BEEN_VOTE",
  SET_ARISAN_HISTORY = "SET_ARISAN_HISTORY",
  SET_LISTS_ARISAN_HISTORY = "SET_LISTS_ARISAN_HISTORY",
  SET_APP_DATA = "SET_APP_DATA",
  SET_THEME = "SET_THEME",
  SET_WINNERS = "SET_WINNERS",
}
